import Logo from '../images/storexplore-logo.png';

const PageLoader = () => {
  return (
    <div className="page-loader">
      <img src={Logo} />
    </div>
  );
};

export default PageLoader;
